import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"arrow-up\"><path d=\"M257 232L88 406c-16 18-43 18-60 0l-15-15c-17-18-17-46 0-64l197-205c1 0 1 0 1-1l15-15c9-9 20-14 31-14s22 5 30 14l15 15 1 1 196 205c17 18 17 46 0 64l-15 15c-16 18-44 18-60 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-up.svg
// module id = 175
// module chunks = 0